import img1 from '../images/common/teamRyo.png';
import img2 from '../images/common/teamDavid.png';
import img3 from '../images/common/team8.png';

const dataTeam = [
    {
        id: 1,
        img: img1,
        name: 'Ryo Lin',
        position: 'Founder & Developer',
        listsocial: [
            {
                id: 1,
                icon: 'fa fa-paper-plane',
                link: 'https://t.me/RyoLin'
            },
        ]
    },
    {
        id: 2,
        img: img2,
        name: 'David Lee',
        position: 'COO',
        listsocial: [
            {
                id: 1,
                icon: 'fab fa-twitter',
                link: '#'
            },
        ]
    },
]

export default dataTeam;